import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

export const ERROR_MSG_UNKNOWN_UPDATE_DATETIME = "Unknown last update";
export type UpdatedAtFormatOptions = "datetime" | "time";

@Pipe({
  name: 'updatedAt'
})
export class UpdatedAtPipe implements PipeTransform {
  transform(value: string | null, formatOption: UpdatedAtFormatOptions, fallback: string = ""): string {
    if (!value) return fallback;

    const dateTime = DateTime.fromISO(value);

    if (dateTime.isValid && formatOption === "datetime") {
        const time = dateTime
            .toLocaleString(DateTime.TIME_SIMPLE)
            .replace(" AM", "am")
            .replace(" PM", "pm");

        return `Updated ${time} - ${dateTime.toLocaleString(DateTime.DATE_FULL)}`;
    }
    if (dateTime.isValid && formatOption === "time") {
        const time = dateTime
            .toLocaleString(DateTime.TIME_SIMPLE)
            .replace(" AM", "am")
            .replace(" PM", "pm");

        return `Updated at ${time}`;
    }

    return ERROR_MSG_UNKNOWN_UPDATE_DATETIME;
  }
}
